import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import API from '../utils/Api';

const initialState = {
    messages: [],
  contacts: [],
    loading: false,
    error: null,
};

export const fetchMessages = createAsyncThunk(
  'chat/fetchMessages',
  async (id, thunkAPI) => {
    try {
      const res = await API.get('/chats/'+id);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data.message);
    }
  }
);

export const fetchContacts = createAsyncThunk(
  'chat/fetchContacts',
  async (_, thunkAPI) => {
    try {
      const res = await API.get('/chats/contacts/list');
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data.message);
    }
  }
);

export const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMessages.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMessages.fulfilled, (state, action) => {
                state.loading = false;
                state.messages = action.payload.messages;
                console.log("Messages fetched:", state.messages);
            })
            .addCase(fetchMessages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchContacts.pending, (state) => {
              state.loading = true;
              state.error = null;
            })
            .addCase(fetchContacts.fulfilled, (state, action) => {
              state.loading = false;
              state.contacts = action.payload.data || [];
            })
            .addCase(fetchContacts.rejected, (state, action) => {
              state.loading = false;
              state.error = action.payload;
            })
    },
}); 

export default chatSlice.reducer;